import { DATE_TIME_FORMAT_REG_EXP } from "utils/datetime";

export const insureesFormSchema = [
  {
    id: "id",
    dataType: "integer",
    shownOnForm: false,
    label: "ID",
    value: 0,
    isRequired: false,
    fieldType: "textfield",
  },
  {
    id: "name",
    dataType: "Text",
    shownOnForm: true,
    label: "Full Name",
    value: "",
    isRequired: true,
    maxChar: 255,
    fieldType: "textfield",
  },
  {
    id: "gender",
    dataType: "Text",
    shownOnForm: true,
    label: "Gender",
    value: "Male",
    isRequired: true,
    fieldType: "select",
    textValue: "label",
    valueKey: "value",
    options: () => [
      { value: "Male", label: "Male" },
      { value: "Female", label: "Female" },
      { value: "Other", label: "Other" },
    ],
  },
  {
    id: "dateOfBirth",
    dataType: "Text",
    shownOnForm: true,
    label: "Date of Birth",
    value: "",
    isRequired: false,
    fieldType: "date", // UI will handle date selection, saved as string
  },
  {
    id: "relationship",
    dataType: "Text",
    shownOnForm: true,
    label: "Relationship",
    value: "Self",
    isRequired: true,
    fieldType: "select",
    textValue: "label",
    valueKey: "value",
    options: () => [
      { value: "Self", label: "Self" },
      { value: "Spouse", label: "Spouse" },
      { value: "Child", label: "Child" },
      { value: "Parent", label: "Parent" },
      { value: "Other", label: "Other" },
    ],
  },
  {
    id: "policyId",
    shownOnForm: true,
    label: "Associated Policy",
    value: null,
    isRequired: false,
    fieldType: "autocomplete",
    options: (deps) => deps.policies || [],
    loading: (deps) => deps.policiesLoading,
    onInputChange: (searchValue, deps) => {
      if (deps.onSearchPolicies) {
        deps.onSearchPolicies(searchValue);
      }
    },
    valueKey: "id",
    textValue: "label",
  },
  {
    id: "policyTypeId",
    shownOnForm: true,
    label: "Policy Type",
    value: null,
    isRequired: false,
    fieldType: "autocomplete",
    options: (deps) => deps.policyTypes || [],
    loading: (deps) => deps.policyTypesLoading,
    onInputChange: (searchValue, deps) => {
      if (deps.onSearchPolicyTypes) {
        deps.onSearchPolicyTypes(searchValue);
      }
    },
    valueKey: "id",
    textValue: "label",
  },
];

export const insureesRecord = {
  id: 0,
  name: "",
  gender: "Male",
  dateOfBirth: "",
  relationship: "Self",
  policyId: null,
  policyTypeId: null,
};
